<template>
    <div class="invoice">
        <el-container>
            <el-header>
                <el-form :inline="true" :model="dataForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label-width="110px" label="项目部：">
                                <el-select v-model="dataForm.deptId" placeholder="请选择项目部" @change="getProjectList">
                                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="80px" label="项目名称：">
                                <el-select v-model="dataForm.projectId" placeholder="请选择项目名称">
                                    <el-option :label="projectItem.name" :value="projectItem.id" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label-width="110px" label="分项合同名称：">
                                <el-input v-model="dataForm.subContractName" placeholder="请输入分项合同名称" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <div v-if="showAdvanceFilter">
                            <el-col :span="6">
                                <el-form-item label-width="120px" label="分项合同名编号：">
                                    <el-input v-model="dataForm.subContractSerial" placeholder="请输入分项合同名编号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="110px" label="销方名称：">
                                    <el-input v-model="dataForm.billHead" placeholder="请输入销方名称" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="销方税号：">
                                    <el-input v-model="dataForm.taxPayerCode" placeholder="请输入销方税号" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="110px" label="发票代码：">
                                    <el-input v-model="dataForm.billCode" placeholder="请输入发票代码" clearable></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="120px" label="发票号码：">
                                    <el-input v-model="dataForm.billNumber" placeholder="请输入发票号码" clearable></el-input>
                                </el-form-item>
                            </el-col>
<!--                            <el-col :span="12">-->
<!--                                <el-form-item label="不含税金额：">-->
<!--                                    <div class="fixStyle">-->
<!--                                        <el-input v-model="dataForm.amountWithoutTaxMin" placeholder="请输入最小不含税金额" clearable></el-input>-->
<!--                                        <div class="lineBox">——</div>-->
<!--                                        <el-input v-model="dataForm.amountWithoutTaxMax" placeholder="请输入最大不含税金额" clearable></el-input>-->
<!--                                    </div>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
                            <el-col :span="12">
                                <el-form-item label-width="110px" label="税额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.taxMin" placeholder="请输入最小税额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.taxMax" placeholder="请输入最大税额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="110px" label="发票金额：">
                                    <div class="fixStyle">
                                        <el-input v-model="dataForm.amountMin" placeholder="请输入最小发票金额" clearable></el-input>
                                        <div class="lineBox">——</div>
                                        <el-input v-model="dataForm.amountMax" placeholder="请输入最大发票金额" clearable></el-input>
                                    </div>
                                </el-form-item>
                            </el-col>
<!--                            <el-col :span="6">-->
<!--                                <el-form-item label-width="80px" label="税率：">-->
<!--                                    <el-input v-model="dataForm.taxRate" placeholder="请输入税率" clearable></el-input>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
                            <el-col :span="6">
                                <el-form-item label-width="110px" label="发票类型：">
                                    <el-select v-model="dataForm.billType" placeholder="请选择发票类型">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="增值税专用发票" value="VAT"></el-option>
                                        <el-option label="普通发票" value="PLAIN"></el-option>
                                        <el-option label="通行费发票" value="PASS"></el-option>
                                        <el-option label="未知类型" value="UNKNOWN"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
<!--                            <el-col :span="6">-->
<!--                                <el-form-item label-width="80px" label="发票种类：">-->
<!--                                    <el-select v-model="dataForm.billInvoiceType" placeholder="请选择发票种类">-->
<!--                                        <el-option label="全部" value=""></el-option>-->
<!--                                        <el-option label="电子发票" value="ELECTRONIC"></el-option>-->
<!--                                        <el-option label="纸质发票" value="PAPER"></el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->
                            <el-col :span="6">
                                <el-form-item label-width="80px" label="是否认领：">
                                    <el-select v-model="dataForm.isClaimed" placeholder="请选择是否认领">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="是" :value="1"></el-option>
                                        <el-option label="否" :value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="110px" label="开票日期：">
                                    <el-date-picker
                                            v-model="invoiceDate"
                                            type="daterange"
                                            @change="invoiceDateChange"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="120px" label="认领日期：">
                                    <el-date-picker
                                            v-model="claimDate"
                                            @change="claimDateChange"
                                            type="daterange"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label-width="110px" label="金额是否匹配：">
                                    <el-select v-model="dataForm.isAmountMatch" placeholder="请选择金额是否匹配">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option label="是" :value="1"></el-option>
                                        <el-option label="否" :value="0"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </div>
                        <el-col :span="showAdvanceFilter? 18 : 6" class="btnRight">
                            <el-form-item class="btnList">
                                <el-button type="primary" @click="query()">查 询</el-button>
                                <el-button  type="info" @click="reset()">重 置</el-button>
                                <el-button type="text" @click="moreScreen">{{showAdvanceFilter?'收起':'高级筛选'}}</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row>
                    <el-col :span="24">
                        <div class="operatePanel">
                            <el-button
                                    v-if="btnAuthorize.importBtn.btnEnable"
                                    type="primary"
                                    icon="el-icon-upload2"
                                    @click="importHandle()"
                            >导入发票信息</el-button>
                            <el-button
                                    v-if="btnAuthorize.approve.btnEnable"
                                    type="primary"
                                    icon="el-icon-top"
                                    @click="claimAutoMatch()"
                            >匹配导入发票</el-button>
                            <el-button
                                    v-if="btnAuthorize.create.btnEnable"
                                    type="primary"
                                    icon="el-icon-check"
                                    @click="confirmHandle()"
                            >发票认领</el-button>
                            <el-button
                                    v-if="btnAuthorize.delete.btnEnable"
                                    type="primary"
                                    icon="el-icon-close"
                                    @click="cancelHandle()"
                            >取消认领</el-button>
                            <el-button
                                    v-if="btnAuthorize.export.btnEnable"
                                    type="primary"
                                    icon="el-icon-download"
                                    @click="exportHandle()"
                            >导出</el-button>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main ref="main">
                <el-table
                        ref="dataTable"
                        :data="invoiceList"
                        highlight-current-row
                        @selection-change="handleSelectionChange"
                        @row-click="rowClicked"
                        @cell-dblclick="dblclickDetail"
                        @sort-change="sortChange"
                        size="mini"
                        height="100%"
                        border
                >
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                  <el-table-column
                      prop="fullElectronicBillNumber"
                      label="全电发票号码"
                      :show-overflow-tooltip="true"
                  ></el-table-column>
                    <el-table-column
                            prop="billCode"
                            label="发票代码"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billNumber"
                            label="发票号码"
                            :show-overflow-tooltip="true"
                    >
                      <template slot-scope="scope">
                        <span>{{scope.row.billNumber? scope.row.billNumber: scope.row.fullElectronicBillNumber ? scope.row.fullElectronicBillNumber: ''}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                            prop="invoiceDate"
                            label="开票日期"
                            sortable="custom"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="amount"
                            label="发票金额（元）"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="100px"
                            prop="tax"
                            label="票面税额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="amountDeduct"
                            label="有效抵扣税额（元）"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="buyerIdentificationNumber"
                            label="购买方识别号"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="billHead"
                            label="销售方纳税人名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="taxPayerCode"
                            label="销售方纳税人识别号"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            width="120px"
                            prop="billSource"
                            label="发票来源"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="billTypeShow"
                        label="票种"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        prop="billStatus"
                        label="发票状态"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
<!--                    <el-table-column-->
<!--                            prop="billTypeShow"-->
<!--                            label="是否增值税发票"-->
<!--                            width="120px"-->
<!--                            :show-overflow-tooltip="true"-->
<!--                    ></el-table-column>-->
                    <el-table-column
                            prop="isClaimedShow"
                            label="是否认领"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="claimDate"
                            sortable="custom"
                            width="120px"
                            label="认领日期"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="isAmountMatchShow"
                            label="金额是否匹配"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="deptName"
                            label="项目部"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="projectName"
                            label="项目名称"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="subContractName"
                            label="分项合同名称"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                            prop="subContractSerial"
                            label="分项合同编码"
                            width="120px"
                            :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="dataForm.pageIndex"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :page-size="dataForm.pageSize"
                        layout="total, prev, pager, next, sizes, jumper"
                        :total="total"
                ></el-pagination>
            </el-footer>
        </el-container>

        <claim-upload v-if="uploadVisible" ref="queryUpload" @refreshDataList="query"></claim-upload>
        <claim-confirm v-if="confirmVisible" ref="confirm" @refreshDataList="query"></claim-confirm>

    </div>
</template>

<script>
    import {
        getIncomeClaimListService,
        getDeptListService,
        getProjectListService,
        claimAutoMatchService,
        claimCancelService,
        claimExportService,
    } from '@/services/invoiceServices'
    import claimUpload from './claim-upload'
    import ClaimConfirm from "./claim-confirm";
    import {exportExcelService2} from "../../../services/allContractServices";
    export default {
        name: "invoiceClaim",
        data(){
            return {
                dataForm:{
                    deptId:'',
                    projectId:'',
                    subContractName:'',
                    subContractSerial:'',
                    billHead:'',
                    taxPayerCode:'',
                    billCode:'',
                    billNumber:'',
                    taxRate:'',
                    billInvoiceType:'',
                    billType:'',
                    isClaimed:'',
                    isAmountMatch:'',
                    taxMin: '',
                    taxMax: '',
                    amountWithoutTaxMin:'',
                    amountWithoutTaxMax: '',
                    amountMax:'',
                    amountMin:'',
                    pageIndex: 1,
                    pageSize: 10,
                    inputBillListOrderTypeEnum: 'CLAIM_DATE_DESC',
                    invoiceDateStart: '',
                    invoiceDateEnd: '',
                    claimDateStart: '',
                    claimDateEnd: '',
                },
                total:0,
                showAdvanceFilter: false,

                deptList:[], //项目部列表
                projectList:[], //项目列表
                invoiceList:[], //表格数据列表
                selectItems:[], //选中的列表
                invoiceDate: [], //开票日期
                claimDate: [], //认领日期

                uploadVisible:false, //导入发票弹窗
                confirmVisible:false, //发票认领弹窗
                btnAuthorize: {
                    importBtn: { key: "import", btnEnable: false },
                    approve: { key: "approve", btnEnable: false },
                    create: { key: "create", btnEnable: false },
                    delete: { key: "delete", btnEnable: false },
                    export: { key: "export", btnEnable: false }
                },
            }
        },
        props: {
            menuCode: {
                type: String
            }
        },
        components:{
            ClaimConfirm,
            claimUpload
        },
        methods:{
            onActive(menuCode) {
                this.$getRoleBtns(menuCode, this.btnAuthorize);
                this.getInvoiceList();
                this.getDeptList();
            },
            //根据条件查询
            query(){
                this.dataForm.pageIndex = 1;
                this.getInvoiceList();
            },
            //重置数据
            reset(){
                this.dataForm = {
                    deptId:'',
                    projectId:'',
                    subContractName:'',
                    subContractSerial:'',
                    billHead:'',
                    taxPayerCode:'',
                    billCode:'',
                    billNumber:'',
                    taxRate:'',
                    billInvoiceType:'',
                    billType:'',
                    isClaimed:'',
                    isAmountMatch:'',
                    taxMin: '',
                    taxMax: '',
                    amountWithoutTaxMin:'',
                    amountWithoutTaxMax: '',
                    amountMax:'',
                    amountMin:'',
                    pageIndex: 1,
                    pageSize: 10,
                    inputBillListOrderTypeEnum: 'CLAIM_DATE_DESC',
                    invoiceDateStart: '',
                    invoiceDateEnd: '',
                    claimDateStart: '',
                    claimDateEnd: '',
                }
                this.projectList = [];
                this.invoiceDate = [];
                this.claimDate = [];
                this.getInvoiceList();
            },
            /**
             * 获取列表数据
             * */
            getInvoiceList(){
                let paramsData = {
                    ...this.dataForm
                }
                getIncomeClaimListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        console.log(res)
                        this.invoiceList = res.data;
                        this.total = res.total;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  获取项目列表
             * */
            getProjectList(){
                this.dataForm.projectId = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //导入发票信息
            importHandle(){
                this.uploadVisible = true
                this.$nextTick(() => {
                    this.$refs.queryUpload.init()
                })
            },
            //发票认领
            confirmHandle(){
                if(this.selectItems.length != 0){
                    let flag = this.selectItems.every(item => item.isClaimedShow === '否')
                    if(flag){
                        let idList = []
                        this.selectItems.map(item => {
                            idList.push(item.id)
                        })
                        this.confirmVisible = true
                        this.$nextTick(() => {
                            this.$refs.confirm.dataForm.idList = idList;
                            this.$refs.confirm.init();
                        })
                    }else{
                        this.$message.error("请选择未认领的发票进行认领");
                    }
                }else{
                    this.$message.error("请至少选择一条发票进行认领");
                }
            },
            //取消发票认领
            cancelHandle(){
                if(this.selectItems.length != 0){
                    this.$confirm("确认取消认领发票", "取消认领", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let flag = this.selectItems.every(item => item.isClaimedShow === '是')
                        if(flag){
                            let idList = []
                            this.selectItems.map(item => {
                                idList.push(item.id)
                            })
                            this.claimCancel(idList)
                        }else{
                            this.$message.error("请选择已认领的发票进行操作");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });

                }else{
                    this.$message.error("请至少选择一条发票进行认领");
                }
            },
            /**
             *  匹配导入发票
             * */
            claimAutoMatch(){
                claimAutoMatchService().then( res => {
                    if(res.code == 10000000){
                        // this.deptList = res.data;
                        this.$message.success('匹配成功');
                        this.getInvoiceList();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  取消发票认领
             * */
            claimCancel(idList){
                let params = {
                    idList: idList
                }
                claimCancelService(params).then( res => {
                    if(res.code == 10000000){
                        this.$message.success('取消认领操作成功');
                        this.getInvoiceList();
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             *  导出发票认领列表
             * */
            exportHandle(){
                let paramsData = {
                    ...this.dataForm,
                    pageSize: 10000,
                }
                claimExportService(paramsData).then( res => {
                    if(res.code == 10000000){
                        exportExcelService2(res.data).then(res1 => {
                            this.$message.success('导出成功');
                        });
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            moreScreen() {
                this.showAdvanceFilter = !this.showAdvanceFilter;
            },
            // 列代表多选回调
            handleSelectionChange(val) {
                this.selectItems = val;
            },
            // 点击选中行
            rowClicked(row, event, column) {
                this.$refs.dataTable.toggleRowSelection(row);
            },
            dblclickDetail(row, column, cell, event) {
                this.bus.$emit("navMenuChange", {
                    routeId: "invoiceClaimDetail",
                    routeParam: {
                        id: row.id
                    }
                });
            },
            sortChange(row){
                console.log(row)
                if(row.prop == 'claimDate'){
                    if(row.order == 'ascending'){
                        this.dataForm.inputBillListOrderTypeEnum = 'CLAIM_DATE_ASC'
                    }else if(row.order == 'descending'){
                        this.dataForm.inputBillListOrderTypeEnum = 'CLAIM_DATE_DESC'
                    }else {
                        this.dataForm.inputBillListOrderTypeEnum = 'CLAIM_DATE_DESC'
                    }
                }else {
                    if(row.order == 'ascending'){
                        this.dataForm.inputBillListOrderTypeEnum = 'INVOICE_DATE_ASC'
                    }else if(row.order == 'descending'){
                        this.dataForm.inputBillListOrderTypeEnum = 'INVOICE_DATE_DESC'
                    }else {
                        this.dataForm.inputBillListOrderTypeEnum = 'CLAIM_DATE_DESC'
                    }
                }

                this.query()
            },
            claimDateChange(value) {
                if (value?.length > 1) {
                    this.dataForm.claimDateStart = value[0];
                    this.dataForm.claimDateEnd = value[1];
                } else {
                    this.dataForm.claimDateStart = "";
                    this.dataForm.claimDateEnd = "";
                }
            },
            invoiceDateChange(value) {
                if (value?.length > 1) {
                    this.dataForm.invoiceDateStart = value[0];
                    this.dataForm.invoiceDateEnd = value[1];
                } else {
                    this.dataForm.invoiceDateStart = "";
                    this.dataForm.invoiceDateEnd = "";
                }
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .btnRight {
        display: flex;
        justify-content: flex-end;
        .btnList{
            text-align: right;
        }
    }
    .fixStyle{
        display: flex;
        align-items: center;
        .lineBox{
            margin: 0 10px;
        }
    }
</style>
